export const DISMISS_ERROR = 'dismiss_error';

export const dismissError = () => ({
	type: DISMISS_ERROR
});
